// removed by extract-text-webpack-plugin
module.exports = {"customList":"customList__2PACH"};


//////////////////
// WEBPACK FOOTER
// ./components/nfoPage/whyNfo/whyNfo.scss
// module id = 501
// module chunks = 68